import ReactRailsUJS from 'react_ujs'
import Loader from '@/public/Loader'

// One entry by design: public/Loader dispatches every customer-facing
// component through a lazy import, so nothing else needs its own entry and
// static import here. esbuild has no `splitting: true`, so those lazy imports
// are still inlined into this bundle today -- the pattern is what makes a
// future split possible, not something it currently achieves.
const componentMap = {
  'public/Loader': Loader,
}

ReactRailsUJS.getConstructor = function getConstructor(className) {
  const mappedComponent = componentMap[className]
  if (mappedComponent) {
    return mappedComponent
  }

  const globalComponent = window[className]
  if (globalComponent) {
    return globalComponent
  }

  console.error('❌ Component not found:', className)
  console.error('Available in map:', Object.keys(componentMap))
  console.error('Available globally:', Object.keys(window).filter((key) => typeof window[key] === 'function'))

  throw new Error(`Cannot find component: '${className}'. Make sure your component is available to render.`)
}

ReactRailsUJS.mountComponents()

document.addEventListener('DOMContentLoaded', () => {
  ReactRailsUJS.mountComponents()
})

document.addEventListener('turbo:load', () => {
  ReactRailsUJS.mountComponents()
})

document.addEventListener('turbo:frame-load', () => {
  ReactRailsUJS.mountComponents()
})

document.addEventListener('turbo:render', () => {
  ReactRailsUJS.mountComponents()
})

document.addEventListener('turbo:before-stream-render', (event) => {
  const streamTarget = event.detail.newStream.target
  if (streamTarget) {
    const targetElement = document.getElementById(streamTarget)
    if (targetElement) {
      ReactRailsUJS.unmountComponents(targetElement)
    }
  }

  setTimeout(() => {
    ReactRailsUJS.mountComponents()
  }, 50)
})

document.addEventListener('turbo:before-render', (e) => {
  ReactRailsUJS.unmountComponents(e.target)
})

document.addEventListener('turbo:before-frame-render', (e) => {
  ReactRailsUJS.unmountComponents(e.target)
})

